<svelte:body on:item={put_item}/>
<script>
    import _ from 'lodash';
    import {validate_int} from '../../../validators.js';
    import {parameter, network} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import RalColor from "../../parts/RalColor.svelte";
    import {decode, encode} from "../../../helpers";
    import PodokonnikMaterialList from "../../parts/PodokonnikMaterialList.svelte";
    import DopMaterialList from "../../parts/DopMaterialList.svelte";

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;


    let fetchedData = null;


    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let fetched = await network.fetch_tovar(item.idTovar)
            let json = JSON.parse(decode(fetched.ind3))

            fetchData = await fetch();
            width.set(json.width)
            height.set(json.height)
            sideControl = json.sideControl
            kursDollara = json.kursDollara
            material= json.material
            tipupr = json.tipupr
            count.set(+item.quantity);
            components = json.components;
            comment.set(item.comment);
            change();
        }
    };

    let components = {}

    const fetch = async () => {
        let result = await network.fetch_data('Вертикальные жалюзи', 'Вертикальные жалюзи');
        let filtered = result.filter(el => el.name.startsWith('Вертикальные жалюзи') && el.flag === '1')

        return {
            name: _.groupBy(result, 'name'),
            materials: Array.from(new Set(filtered.map(el => el.ind1.trim().capitalize()).sort((a, b) => a.localeCompare(b)))),
            options,
            result,
        }
    }

    let
        width = parameter('width', '500'),
        height = parameter('height', '1400'),
        material = 'Аргос',
        cvet = 'бежевый', // цвет
        nakl = 'Нет',
        arc = 'Нет',
        cher = 'Нет',
        kriv = 'Нет',
        sideControl = 'Слева',
        tipupr = 'T1 (к упр)',
        kursDollara = '70',

        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1)
    ;

    let fetchData = fetch();

    const changeMaterial = (colors) => cvet = colors?.[0] ?? ''

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,
            w = +$width,
            h = +$height
        ;

        let result = {
            type: 'Вертикальные жалюзи',
            name: 'Вертикальные жалюзи',
            subname: [
                $width + 'x' + $height, ', - ', material, ', цвет - ', cvet, ', управление ', sideControl.toLowerCase(), ', ', tipupr
                ,( nakl=='Нет' ?'' : ', наклонные')
                ,( arc=='Нет' ?'' : ', арочные')
                ,( cher=='Нет' ?'' : ', чередование цветов')
                ,( kriv=='Нет' ?'' : ', криволинейные рисунки')
            ].join(''),
            title: [
                'Вертикальные жалюзи ', ' ', $width + 'x' + $height, ', - ', material, ', цвет - ', cvet, ', управление ', sideControl.toLowerCase(), ', ', tipupr
                ,( nakl=='Нет' ?'' : ', наклонные')
                ,( arc=='Нет' ?'' : ', арочные')
                ,( cher=='Нет' ?'' : ', чередование цветов')
                ,( kriv=='Нет' ?'' : ', криволинейные рисунки')
            ].join(''),
            params: {
                ind1: [' ', sideControl, ' ',
                    ' '
                ].join(''),
                ind2: cvet,
                ind3: encode(JSON.stringify({
                    width: $width,
                    height: $height,
                    cvet,
                    kursDollara,
                    sideControl,
                    nakl,
                    arc,
                    cher,
                    kriv,
                    tipupr,
                    material,
                    components,
                })),
                ind4: w,
                ind5: h,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: options.vStrukture || 127
        };

        kursDollara = parseInt(data.result.find((item) => item.name === 'Курс доллара')?.sebestomost ?? 0);
        let title_addons = []



        _.forEach(data.result, function (item) {
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;
            let nacenki;


            if (components.hasOwnProperty(item.idTovar)) {
                let edIzmer = item.edIzmer.length ? item.edIzmer : 'шт.'

                if (item.name.toLowerCase().includes("металлические бегунки")) {
                    kolvo = Math.ceil(w / 110);
                } else {
                    kolvo = +components[item.idTovar]['count'];
                }

                title_addons.push(`${item.name} - ${kolvo}/${edIzmer}`)
            }




            if (name.includes("вертикальные жалюзи") && cvet == item.ind2 && material == item.ind1) {

                nacenki = 1;

                if (nakl == 'Да'){
                    nacenki = nacenki * 1.4;
                }
                if (arc == 'Да'){
                    nacenki = nacenki * 1.2;
                }
                if (cher == 'Да'){
                    nacenki = nacenki * 1.1;
                }
                if (kriv == 'Да'){
                    nacenki = nacenki * 1.2;
                }


                if (w < 1000){
                    if (h < 1500){
                        kolvo = (1000 * 1500 / 1000000).toFixed(3);
                    }
                    else{
                        kolvo = (1000 * h / 1000000).toFixed(3);
                    }
                }
                else{
                    if (h < 1500){
                        kolvo = (w * 1500 / 1000000).toFixed(3);
                    }
                    else{
                        kolvo = (w * h / 1000000).toFixed(3);
                    }

                }

            }


            if (name.includes("Профиль ал. карниз".toLowerCase())) {
                kolvo = (w + 15) / 1000;
            }

            if (name.includes("Бегунок".toLowerCase())
                || name.includes("Дистанция 110,115,80 мм".toLowerCase())
                || name.includes("Груз ткани 89 мм".toLowerCase())
                || name.includes("Держатель ткани 89 мм".toLowerCase())) {
                kolvo =Math.ceil(w/1000 * 13).toFixed(3) ;
            }

            if (name.includes("Головной бегунок".toLowerCase())) {
                kolvo = 1;
            }

            if (name.includes("Цепь управления".toLowerCase())) {
                kolvo = ((w + h +300) / 1000).toFixed(3) ;
            }

            if (name.includes("Замок цепи управления".toLowerCase())) {
                kolvo = 1;
            }

            if (name.includes("Шнур белый 2 мм".toLowerCase())) {
                kolvo = ((w *2 + h *2  -200) / 1000).toFixed(3) ;
            }


            if (name.includes("Клипса крепления".toLowerCase())) {
                kolvo = 2;
            }
            if (name.includes("Нижняя цепочка 89 мм".toLowerCase())) {
                kolvo = (( h *2 +420) / 1000).toFixed(3);
            }

            if (name.includes("Груз шнура".toLowerCase())
            || name.includes("Стоп-кольцо С".toLowerCase())
                || name.includes("Звездочка".toLowerCase())
                || name.includes("Сборка ВЖ карниз (85)".toLowerCase())
                || name.includes("Пошив (8)".toLowerCase())
                || name.includes("Скоба к головному бегунку".toLowerCase())

            ) {
                kolvo = 1;
            }


            if (name.includes("Ось 4 грани".toLowerCase())) {
                kolvo = ((w +15) / 1000).toFixed(3);
            }




            if (kolvo) {

                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price * kursDollara * (+item.flag) * (name.includes("вертикальные жалюзи") ? nacenki: 1));
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price * kursDollara * (+item.flag) * (name.includes("вертикальные жалюзи") ? nacenki: 1));
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost * kursDollara);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price * kursDollara).toFixed(2),
                        opt: (+item.opt_price * kursDollara).toFixed(2),
                        sebest: (+item.sebestomost * kursDollara).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }

        });

        if (title_addons.length > 0) {
            result.title = `${result.title} | ${title_addons.join(', ')}`;
        }

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);


        /*let mprice = Math.round((result.price.rozn / quantity) / 100 * montage_item.procentSpisania / 100) * 100;
        montage_price = +(montage_item.opt_price > mprice ? montage_item.opt_price * quantity : mprice * quantity).toFixed(2);
        dispatch('mounting', {item: montage_item, price: montage_price});*/


        dispatch('item', result);
    }, 250);

    change();

    $: computedValue = 'vertikjaluzi.png';
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    {@const colors = data.result.filter((el) => el.ind1 === material).map((el) => el.ind2)}
    {@const dop_materials = data.result?.filter((item) =>
        ['Стеновой кронштейн 10см', 'Удлинитель к кронштейну', 'Стеновой кронштейн 7,5см' , 'Кронштейн Армстронг'].some(name =>
            item.name?.toLowerCase().trim() === name.toLowerCase()
        )
    )}



    <div class="card-body " on:keyup={change} on:paste={change} on:change={change}>

        <div class="parent">
            <div class="dollar">
                <div class="alert alert-outline-info fade show text-center" role="alert">Курс доллара: $1
                    = {kursDollara}₽
                </div>
            </div>
            <div class="material">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Материал</label>
                        <select class="form-control form-select" bind:value={material} on:change={() => changeMaterial(colors)}>
                            {#each data.materials as value}
                                <option value="{value}">{value}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>


            <div class="cvet">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Цвет</label>
                        <select class="form-control form-select" bind:value={cvet}>
                            {#each colors as value}
                                <option value="{value}">{value}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>


            <div class="badgeVertik">
                <span class="badge-danger text-white small rounded-2 text-center text-uppercase"> {  ($width > 2850 || $width < 300 || $height > 3000 || $height < 300) ? 'Изделия не являются гарантийными. По всем вопросам рекомендуем обратиться к менеджеру!' : '' }</span>
            </div>
            <div class="width">
                <div class="form-group boxed">
                    <div class="input-wrapper">

                        <label class="form-label">300 ≥ Шир., см ≥ 2850</label>
                        <input type="number"
                               class="form-control text-center { ($width > 2850 || $width < 300) ? 'text-danger' : '' }"
                               step="1"
                               min="300"
                               max="2850"
                               bind:value={$width} use:validate_int={$width}>
                    </div>
                </div>
            </div>

            <div class="height">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">300 ≥ Выс., см ≥ 3000</label>
                        <input type="number"
                               class="form-control text-center { ($height > 3000 || $height < 300  ) ? 'text-danger' : '' }"
                               step="1"
                               min="300"
                               max="3000"
                               bind:value={$height} use:validate_int={$height}>
                    </div>
                </div>
            </div>


            <div class="tipupr">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label ">Тип управления</label>
                        <select class="form-control form-select" bind:value={tipupr}>
                            <option value="T1 (к упр)">T1 (к упр)</option>
                            <option value="T2 (от упр)">Т2 (от упр)</option>
                            <option value="T3 (от центра)">Т3 (от центра)</option>
                            <option value="T4 (к упр)">T4 (к центру)</option>
                            <option value="T8 (состыковка 2-х карнизов)">Т8 — состыковка 2-х карнизов</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="sideControl">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">сторона</label>
                        <select class="form-control form-select" bind:value={sideControl}>
                            <option value="Слева">Слева</option>
                            <option value="Справа">Справа</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="nakl">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Наклонные жалюзи +40%</label>
                        <select class="form-control form-select" bind:value={nakl}>
                            <option value="Нет">Нет</option>
                            <option value="Да">Да</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="arc">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Арочные рисунки +20%</label>
                        <select class="form-control form-select" bind:value={arc}>
                            <option value="Нет">Нет</option>
                            <option value="Да">Да</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="cher">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Чередование цветов +10%</label>
                        <select class="form-control form-select" bind:value={cher}>
                            <option value="Нет">Нет</option>
                            <option value="Да">Да</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="kriv">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Криволинейные рисунки +20%</label>
                        <select class="form-control form-select" bind:value={ kriv }>
                            <option value="Нет">Нет</option>
                            <option value="Да">Да</option>

                        </select>

                    </div>
                </div>
            </div>


            <div class="dop_mat">
                <PodokonnikMaterialList list={dop_materials} bind:components={components}/>
            </div>

            <img class="imgVertik" style="max-width: 200px;max-height: 200px;margin: auto;" src="{`/img/other/vals/${tipupr.substring(0, 2).toLowerCase()}${ sideControl === 'Справа' ? '-sp': ''}.jpg`}">
            <div class="info">
                <span class="form-label text-center">Площадь: : {
                    ($width < 1000) ?
                        (
                            ($height < 1500) ? (1000 * 1500 / 1000000).toFixed(3) : (1000 * $height / 1000000).toFixed(3)
                        ) :
                        (
                            ($height < 1500) ? ($width * 1500 / 1000000).toFixed(3) : ($width * $height / 1000000).toFixed(3)
                        )
                } м.кв.</span>
            </div>

            <div class="count">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Количество</label>
                        <input type="number" class="form-control" min="1" bind:value={$count} use:validate_int={count}>
                    </div>
                </div>
            </div>

            <div class="comment">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <div class="input-wrapper">
                            <label class="form-label">Примечание</label>
                            <textarea class="form-control" bind:value={$comment}></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/await}


<style>
    .parent {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-auto-rows: auto;
        grid-column-gap: 5px;
        grid-row-gap: 0px;
        grid-template-areas:
                    "dollar dollar "
                    "badgeVertik badgeVertik"
                    "material cvet"
                    "width height"
                    "tipupr nakl"
                    "kriv arc"
                    "cher count"
                    "dop_mat dop_mat "
                    "comment comment "
                    "imgVertik imgVertik"
                    "info info";



    }

    @media (min-width: 575.98px) {
        .parent {
            grid-template-columns: repeat(3, 1fr);
            grid-template-areas:
                    "dollar dollar dollar"
                    "badgeVertik badgeVertik badgeVertik"
                    "imgVertik material cvet"
                    "imgVertik width height"
                    "imgVertik tipupr sideControl "
                    "imgVertik nakl kriv"
                    "info arc cher"
                    "info count ."
                    "dop_mat dop_mat dop_mat"
                    "comment comment comment";

        }
    }



    .comment {
        grid-area: comment;
    }
    .count {
        grid-area: count;
    }
    .imgVertik {
        grid-area: imgVertik;
    }

    .dop_mat {
        grid-area: dop_mat;
    }
    .kriv {
        grid-area: kriv;
    }
    .cher {
        grid-area: cher;
    }

    .arc {
        grid-area: arc;
    }


    .nakl {
        grid-area: nakl;
    }


    .height {
        grid-area: height;
    }

    .width {
        grid-area: width;
    }
    .badgeVertik {
        grid-area: badgeVertik;
    }
    .cvet {
        grid-area: cvet;
    }

    .dollar {
        grid-area: dollar;
    }
    .material {
        grid-area: material;
    }
    .sideControl {
        grid-area: sideControl;
    }





</style>